import React from "react";
import { Navigate } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { useAuthContext } from "../../context/AuthContext";

function Loading() {
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
      <Skeleton variant="text" width={260} height={36} />
      <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

/**
 * Painel /platform/xprobase — apenas usuário master no userData (espelho do login).
 * Não aparece no menu; URL direta.
 *
 * Segurança: isto é só UX. Qualquer um pode alterar localStorage; as rotas admin na API exigem JWT válido
 * e o xpro4api revalida master/role no banco a cada request (authMiddleware).
 */
export default function RequireMasterPlatform({ children }) {
  const { userData, bearerToken } = useAuthContext();

  if (!bearerToken) {
    return <Navigate to="/platform/login" replace />;
  }

  if (userData == null) {
    return <Loading />;
  }

  const allowed =
    Number(userData?.master) === 1 ||
    userData?.scope === "platform";

  if (!allowed) {
    return <Navigate to="/settings/billing" replace />;
  }

  return children;
}
